/**
 * Dialog - MUI Dialog Component Wrapper
 * 
 * A thin wrapper around Material-UI Dialog component for consistent imports.
 */

import MuiDialog from "@mui/material/Dialog";

const Dialog = (props) => {
  return <MuiDialog {...props} />;
};

export default Dialog;

